// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ActiveGateSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ActiveGateSignetIcon" ref={forwardedRef} {...props}>
      <path d="M17 11.772a55 55 0 0 0-.04-1.65 56 56 0 0 0-.082-1.63 58 58 0 0 0-.412-3.994l-.001-.007-.004-.024V4.462c-.056-.262-.274-.47-.54-.545a3 3 0 0 0-.276-.066l-.008-.002a60 60 0 0 0-3.979-.581 60 60 0 0 0-3.102-.263H8.55C8.474 2.997 7.996 2.957 7.546 3.38L3.432 7.24c-.45.422-.434.897-.431.97v.006l.002.205v.014a54 54 0 0 0 .303 5.23.427.427 0 0 0 .466.378l.116-.012a7.7 7.7 0 0 0 1.678-.4 4 4 0 0 0 .286-.116l.06-.027.063-.03.155-.078.151-.08.148-.085a4.3 4.3 0 0 0 1.036-.841 4.2 4.2 0 0 0 .723-1.18A8 8 0 0 0 8.619 9.75a19 19 0 0 0 .146-.766L8.78 8.89l.015-.1.029-.196.056-.392.003-.024-1.317.69 2.516-4.229 2.572 4.23-1.332-.691.046.422.038.294.017.095a18 18 0 0 0 .151.761 7.4 7.4 0 0 0 .466 1.425 4.4 4.4 0 0 0 .764 1.168 4.7 4.7 0 0 0 1.06.848l.15.086.095.052.057.03a3 3 0 0 0 .156.08l.06.029.009.005.006.002.022.01.025.01a3 3 0 0 0 .26.098 6 6 0 0 0 .312.091.83.83 0 0 0 .776-.199l.778-.734c.446-.42.431-.89.429-.97v-.008z" />
      <path d="M9.255 11.509a5.5 5.5 0 0 1-.543 1.665 5.9 5.9 0 0 1-1.11 1.473l-.048.046-.119.112-.17.153-.195.164-.008.007-.016.012-.058.04-.112.075a6 6 0 0 1-.42.246 10.3 10.3 0 0 1-1.75.72 61 61 0 0 0 3.42.496 48 48 0 0 0 .79.082l.347-5.29z" />
      <path d="m13.295 15.144.063.043.061.04a5 5 0 0 0 .325.189c-.498.628-.914.962-1.275 1.203-.61.409-.93.384-1 .379h-.051l-.46-5.65.026.146a5.7 5.7 0 0 0 .6 1.674 6.3 6.3 0 0 0 1.116 1.448l.164.157q.055.052.112.1l.057.051a3 3 0 0 0 .172.147l.043.036.022.018.01.009z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ActiveGateSignetIcon = /* @__PURE__ */ Object.assign(
  ActiveGateSignetIconComponent,
  { displayName: 'ActiveGateSignetIcon' },
);
